module.exports = __webpack_public_path__ + "static/img/cooperationBgTwo.7dcd77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperationBgTwo.png
// module id = o0SX
// module chunks = 1